import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ImageContainer component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    imageContainer: {
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      '&[data-ui-type=primary]': {
        // paddingTop: theme.spacing(1),
        // paddingBottom: theme.spacing(2),

        '& $title': {
          // padding: theme.spacing(2),
        },
      },
    },

    label: {
      marginTop: '0',
      marginBottom: '5px',
    },

    titleWrapper: {
      padding: '0 1.6rem 2rem 1.6rem',
    },
    title: {
      alignItems: 'center',
      color: variables.colorV2.text.header,
      display: 'flex',
      fontSize: '2rem',
      fontWeight: 400,
      justifyContent: 'space-between',
      lineHeight: '2.5rem',
      paddingBottom: '1rem',
    },
    panel: {
      background: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      flex: '0 1 auto',
      overflowY: 'hidden',
      padding: '2rem 1.6rem',
    },
    settingsContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxHeight: 'calc(100vh - 228px)',
      overflowY: 'auto',
      '& .MuiAccordion-root': {
        paddingBottom: '2rem',
      },
    },
    header: {
      display: 'flex',
      gap: '8px',
      borderBottom: `solid 1px ${variables.color.primary.lightGray}`,
      marginBottom: '10px',
      marginTop: '1.5rem',
      paddingLeft: '30px',
    },
    headerItem: {
      height: '25px',
      width: '109px',
      fontSize: '10px',
      textTransform: 'uppercase',
    },
    caption: {},
    maxScale: {
      width: '153px',
      display: 'flex',
      gap: '10px',
      flexDirection: 'column',
      paddingBottom: '10px',
    },

    editModeContainer: {
      padding: '2rem 1.6rem 2rem 1.6rem',
    },

    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      // minWidth: '60rem',
      // width: '60rem',
    },

    save: {
      // marginLeft: 'auto',
      '&:disabled': {
        // backgroundColor: variables.color.primary.backgroundLighterGray,
        // border: `0.1rem solid ${variables.color.primary.lightGrayDarker}`,
        // color: variables.color.primary.lightGrayDarker,
      },
    },

    close: {
      '&&': {
        borderRadius: '3.2rem',
        fontWeight: 500,
        marginRight: '.8rem',
        // border: `1px solid ${variables.colorV2.button.contained.secondary.border.default}`,
        // color: variables.colorV2.button.contained.secondary.text.default,

        '&:hover': {
          // backgroundColor: variables.colorV2.button.contained.secondary.background.hover,
          // border: `1px solid ${variables.colorV2.button.contained.secondary.border.hover}`,
          // color: variables.colorV2.button.contained.secondary.text.hover,
        },
      },
    },
  }),
);
